import { DynamicStandaloneLink, DynamicStandaloneLinkProps } from '@/components/Link';
import { componentTheme } from '@/styles/ArticleSlider';
import { StandaloneComponent } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';

export type ArticleSliderLinkProps = DynamicStandaloneLinkProps;

export const ArticleSliderLinkComponent: StandaloneComponent<ArticleSliderLinkProps> = (props) => {
  return (
    <DynamicStandaloneLink
      {...mergeProps(
        {
          options: {
            theme: componentTheme('link'),
          },
        },
        props
      )}
    />
  );
};
